





























































































































































































































import i18n from "../../../locale";
import { SharingRole, sp } from "@pnp/sp/presets/all";
import { Dictionary } from "lodash";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import {
  ApiMessage,
  CustomerModel,
  CustomersApi,
  GroupModel,
  GroupsApi,
  UserModel,
  UsersApi,
} from "../../../apis";

extend("group", {
  ...required,
  message: (_, values) => i18n.t("message.group_required", values).toString(),
});

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class InviteDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop() type: string;
  @Prop() data?: UserModel;
  email: string = "";
  selectedGroups = [];
  selectedOrganization: any = null;
  selectedCustomer: any = null;
  selectedLocations: any = [];
  groups: GroupModel[] = [];
  groupsClient: GroupModel[] = [];
  groupsECO2: GroupModel[] = [];
  customers: CustomerModel[] = [];
  isAllLocation = false;
  LOCATIONS: any[] = [];
  show = false;
  removeSpecificLocations(id) {
    this.selectedLocations = this.selectedLocations.filter(
      (location) => location !== id
    );
    this.$nextTick(() => {
      this.LOCATIONS = this.LOCATIONS;
    });
  }
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  async onChangeCustomer(option) {
    this.isAllLocation = false;
    this.LOCATIONS = [];
    this.selectedLocations = [];
    if (option && option.value) {
      try {
        new CustomersApi()
          .getActiveLocationsByCustomerId({ id: option.value })
          .then((resp) => {
            this.LOCATIONS = resp.data.data.map((el) => {
              return { value: el.id, text: el.locationName };
            });
          });
      } catch (error) {
        this.$util.showError(error);
      }
    }
  }
  @Watch("value", { deep: true })
  async onValueWatch(val) {
    this.$util.showLoading();
    if (val) {
      this.$store.commit("API_MESSAGES_EMPTY");
      if (this.type !== "INVITE" && this.data) {
        this.selectedGroups = this.data.groups.map((g) => g.id);
        this.email = this.data.email;
        this.selectedOrganization = this.lodash.find(
          this.ORGANIZATIONS,
          (org) => org.value === this.data.organization
        );
      } else {
        this.email = "";
        this.selectedOrganization = this.ORGANIZATIONS[0];
      }
      const rs = await new GroupsApi().getGroups();
      this.groups = rs.data.data;
      this.groupsClient = this.groups.filter((g) => g.code === "CLIENT");
      this.groupsECO2 = this.groups.filter((g) => g.code !== "CLIENT");

      const getCustomersResp = await new CustomersApi().getCustomers();
      this.customers = getCustomersResp.data.data;
      this.customers = this.customers.filter(c=>c.status != "Inactive");
    } else {
      this.reset();
    }
    this.$util.hideLoading();
    this.show = val;
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  get CUSTOMERS() {
    return this.customers.map((val) => ({
      text: val.companyName,
      value: val.id,
    }));
  }

  get ORGANIZATIONS() {
    return [
      { value: "ECO2", text: this.$t("page.user.organization.ECO2") },
      { value: "CLIENT", text: this.$t("page.user.organization.CLIENT") },
    ];
  }

  reset() {
    this.selectedGroups = [];
    this.selectedCustomer = null;
    this.selectedOrganization = null;
    this.isAllLocation = false;
    this.LOCATIONS = [];
    this.selectedLocations = [];
    this.observer.reset();
  }

  onOrganizationChange() {
    this.selectedGroups = [];
  }

  async onSubmit() {
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    // const loading = this.$loading.show();
    this.$util.showLoading();
    try {
      if (this.type === "INVITE") {
        try {
          // await sp.utility.sendEmail({
          //   To: ["tuyen.kieu@tpssoft.com"],
          //   Subject: "This email is about...",
          //   Body: "Here is the body. <b>It supports html</b>",
          //   AdditionalHeaders: {
          //     "content-type": "text/html",
          //   },
          // });
          await new UsersApi().postDoInviteV2({
            postUserInviteRequest: {
              email: this.email,
              organization: this.selectedOrganization.value,
              customerId:
                this.selectedOrganization &&
                this.selectedOrganization.value === "CLIENT"
                  ? this.selectedCustomer.value
                  : undefined,
              groupIds: this.selectedGroups,
              accessLocations: this.selectedLocations,
              isAllLocation: this.isAllLocation,
            },
          });
        } catch (error) {
          const messages: any[] = error.data.messages || [];
          for (let message of messages) {
            if (message.code === "email_exist") {
              return;
            }
          }
          this.$util.showError("invite");
        }
      } else if (this.data) {
        await new UsersApi().putDoUpdateUser({
          putUserRequest: {
            userId: this.data.id,
            customerId:
              this.selectedOrganization &&
              this.selectedOrganization.value === "CLIENT"
                ? this.selectedCustomer.value
                : undefined,
            groupIds: this.selectedGroups,
            accessLocations: this.selectedLocations,
            isAllLocation: this.isAllLocation,
            action: "APPROVE",
          },
        });
      }
      this.$emit("update:value", false);
      this.$emit("closed");
    } catch (error) {
    } finally {
      // loading.hide();
      this.$util.hideLoading();
    }
  }
}
